import React from 'react'
// import { Link } from 'react-router-dom'
import { HashLink as Link } from 'react-router-hash-link';
function Btn1(props) {
  return (
    <Link data-aos={props.aos} className={props.cl+" btn-1"} to={props.url}>{props.value}</Link>

  )
}
Btn1.defaultProps={
  value:"Button",
  url:"/#",
  cl:"button",
  aos:"nothing"
}
export default Btn1